'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'face-sad-sweat';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e38a';
var svgPathData = 'M528 256c0 114.9-93.1 208-208 208-56.8 0-108.2-22.7-145.8-59.6-3.1 17.4-10 33.3-19.9 46.8 44.7 38 102.5 60.8 165.7 60.8 141.4 0 256-114.6 256-256S461.4 0 320 0c-136 0-247.2 106.1-255.5 240 12.8 .1 25.6 4.6 36 13.5l.3 .3c3.6 3.1 7.4 6.6 11.4 10.3-.1-2.7-.2-5.4-.2-8 0-114.9 93.1-208 208-208s208 93.1 208 208zM261.5 398c13.1-18.2 34.4-30 58.5-30s45.4 11.8 58.5 30c7.7 10.8 22.7 13.2 33.5 5.5s13.2-22.7 5.5-33.5c-21.7-30.2-57.3-50-97.5-50s-75.7 19.8-97.5 50c-7.7 10.8-5.3 25.8 5.5 33.5s25.8 5.3 33.5-5.5zM368 272a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM240 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm22.1-158.1c-7.8-7.8-20.5-7.8-28.3 0l-7.4 7.4c-18.3 18.3-41.8 30.4-67.3 34.6l-2.5 .4c-10.9 1.8-18.3 12.1-16.4 23s12.1 18.3 23 16.4l2.5-.4c33.7-5.6 64.8-21.6 89-45.8l7.4-7.4c7.8-7.8 7.8-20.5 0-28.3zm115.7 28.3l7.4 7.4c24.2 24.2 55.3 40.2 89 45.8l2.5 .4c10.9 1.8 21.2-5.5 23-16.4s-5.5-21.2-16.4-23l-2.5-.4c-25.5-4.2-49-16.4-67.3-34.6l-7.4-7.4c-7.8-7.8-20.5-7.8-28.3 0s-7.8 20.5 0 28.3zM128 384c0-36.9-32.5-71.1-58.8-94.1-3-2.6-7.4-2.6-10.4 0-26.3 23-58.8 57.2-58.8 94.1 0 36.4 27.6 64 64 64s64-27.6 64-64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceSadSweat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;